<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent" v-if="!isModal"></column-header>
    <div>
      <div class="row" v-if="!isModal">
				<div class="col-md-12">
          <h3 v-if="deliverymethodgroup.name">{{ deliverymethodgroup.name }}</h3>
          <h3 v-else>{{ _('Delivery method group') }}</h3>
        </div>
      </div>
      <div class="modal-header" v-else>
        <h3 v-if="deliverymethodgroup.name">{{ deliverymethodgroup.name }}</h3>
        <h3 v-else>{{ _('Delivery method group') }}</h3>
      </div>
      <div :class="(isModal ? 'modal-body' : '')">
        <lock-info v-if="locked" :locked="locked" :lockStatus="lockStatus" v-on:forceLock="getComponentLock(true)" />
        <editor-tabs id="tabNavi" :tabs="tabList" :selected="selectedTab" :id-prefix="tabIdPrefix" v-on:select="tab" />
        <div class="tab-content">
          <transition-group name="fade">
            <div v-bind="tabPanel('general')" class="tab-pane active" id="general" v-if="isTabActive('general')" key="general">
              <div class="row">
                <div class="col-sm-6 leftcol">
                  <h3>{{ _('General') }}</h3>
                  <div class="form-group">
                    <label for="name">{{ _('Name') }}</label>
                    <input type="text" class="form-control" v-model="deliverymethodgroup.name" :placeholder="_('Enter the delivery method group\'s name')" />
                  </div>
                  <div class="form-group">
                    <label for="price">{{ _('Price inc. vat') }}</label>
                    <div class="input-group">
                      <input type="text" class="form-control" v-model="deliverymethodgroup.price" :placeholder="_('Enter the delivery method group\'s price')" />
                      <div class="input-group-addon">{{ settings.currency }}</div>
                    </div>
                    <p class="help-block"><i class="fa fa-fw fa-info-circle"></i> {{ _('This price will be the total price of all deliveries matching the selected delivery methods in a single order.') }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div v-bind="tabPanel('deliverymethods')" class="tab-pane active" id="deliverymethods" v-if="isTabActive('deliverymethods')" key="deliverymethods">
              <div class="row">
                <div class="col-sm-6 leftcol">
                  <h3>{{ _('Delivery methods') }}</h3>
                  <div class="form-group" style="max-height: 400px; overflow-y: auto">
                    <draggable v-if="selectedDeliverymethods && selectedDeliverymethods.length" v-model="selectedDeliverymethods" tag="ul" draggable=".list-group-item" :delay="100" :delayOnTouchOnly="true" :componentData="{ attrs: { class: 'o-sortable-groups list-group' }}">
                      <li :class="'list-group-item' + (selectedDeliverymethod === deliverymethod.id ? ' list-group-item-info' : '')" v-for="deliverymethod in selectedDeliverymethods" v-on:click="selectedDeliverymethodClicked(deliverymethod.id)">{{ deliverymethod.name }}</li>
                    </draggable>
                    <ul class="list-group" v-else>
                      <li class="list-group-item"><i>{{ _('No delivery methods selected') }}</i></li>
                    </ul>
                  </div>
                  <div class="form-group">
                    <button type="button" class="btn btn-success" v-on:click="addDeliverymethodDialog"><span class="fa fa-fw fa-plus"></span> {{ _('Add delivery method') }}</button>
                    <button type="button" class="btn btn-danger" v-if="selectedDeliverymethod" v-on:click="removeDeliverymethod"><span class="fa fa-fw fa-trash"></span> {{ _('Delete') }}</button>
                  </div>
                 </div>
              </div>
            </div>
          </transition-group>
        </div>
      </div>
    </div>
    <nav :class="(isModal ? 'modal-footer' : 'save-bar')">
      <div class="row">
        <div class="col-md-12">
          <button class="btn btn-danger" v-on:click="remove" type="button" :disabled="!isRemoveButtonEnabled"><i class="fa fa-fw fa-trash"></i> {{ _('Delete') }}</button>
          <div class="pull-right">
            <button class="btn btn-default" v-on:click="close"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
            <button class="btn btn-success" v-on:click="save" :disabled="!isSaveButtonEnabled"><i :class="'fa fa-fw fa-' + saveButtonIcon"></i> {{ saveButtonText }}</button>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'

export default {
  data () {
    return {
      deliverymethodgroup: {},
      deliverymethods: [],
      selectedDeliverymethod: null,
    }
  },
  mixins: [components],
  computed: {
    tabList () {
      return this.editorTabs([
        { id: 'general', label: this._('General') },
        { id: 'deliverymethods', label: this._('Delivery methods') }
      ])
    },
    selectedDeliverymethods: {
      get () {
        return this.deliverymethodgroup.ownDeliverymethod
      },
      set (newValue) {
        if (!newValue || !newValue.length) {
          this.deliverymethodgroup.ownDeliverymethod = []
          return
        }
        let deliverymethods = []
        newValue.forEach(dm => {
          deliverymethods.push(this.deliverymethods.find(d => parseInt(d.id, 10) === parseInt(dm.id, 10)))
        })
        this.deliverymethodgroup.ownDeliverymethod = deliverymethods
      }
    },
    selectableDeliverymethods () {
      return this.deliverymethods.filter(dm => 
        !this.deliverymethodgroup.ownDeliverymethod.some(own => parseInt(own.id, 10) === parseInt(dm.id, 10)) && 
        (!parseInt(dm.deliverymethodgroup_id, 10) || parseInt(dm.deliverymethodgroup_id, 10) === parseInt(this.deliverymethodgroup.id, 10)) &&
        !parseInt(dm.internal, 10)
      )
    },
  },
  methods: {
    addDeliverymethodDialog () {
      this.showDialog({
        title: this._('Add delivery method'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Add'),
            class: 'success',
            icon: 'check',
            requiredFields: ['deliverymethod'],
            handler: (data) => {
              this.addDeliverymethod(data.deliverymethod)
            }
          }
        ],
        fields: [
          {
            title: this._('Delivery method'),
            type: 'select',
            name: 'deliverymethod',
            options: this.selectableDeliverymethods.map(dm => { return { value: dm.id, name: dm.name } })
          }
        ]
      })
    },
    addDeliverymethod (id) {
      if (!this.deliverymethodgroup.ownDeliverymethod) {
        this.deliverymethodgroup.ownDeliverymethod = []
      }
      let deliverymethod = this.deliverymethods.find(dm => parseInt(dm.id, 10) === parseInt(id, 10))  
      if (deliverymethod) {
        this.deliverymethodgroup.ownDeliverymethod.push(deliverymethod)
      }
    },
    removeDeliverymethod () {
      this.deliverymethodgroup.ownDeliverymethod = this.deliverymethodgroup.ownDeliverymethod.filter(dm => parseInt(dm.id, 10) !== parseInt(this.selectedDeliverymethod, 10))
      this.selectedDeliverymethod = null
    },
    selectedDeliverymethodClicked (id) {
      if (this.selectedDeliverymethod === id) {
        this.selectedDeliverymethod = null
      } else {
        this.selectedDeliverymethod = id
      }
    },
    getDeliverymethodName (id) {
      const deliverymethod = this.deliverymethods.find(dm => parseInt(dm.id, 10) === parseInt(id, 10))
      if (deliverymethod) {
        return deliverymethod.name
      }
      return ''
    },
    getSaveData () {
      const exportFields = [
        'id',
        'name',
        'price',
        'ownDeliverymethod',
      ]
      const data = exportFields.reduce((a, e) => (a[e] = this.deliverymethodgroup[e], a), {})
      return data
    },
    async doRemove () {
      let response
      try {
        this.deleted = true
        response = await axios.delete(this.baseDomain + this.shopId + '/deliverymethodgroups/' + this.deliverymethodgroup.id + '.json?apikey=' + this.apiKey)
      } catch(e) {
        this.deleted = false
        return this.showError(this._('Deletion failed!'))
      }
      this.close()
    },
    async save () {
      this.saving = true
      const data = this.getSaveData()
      let response
      try {
        if (data.id) {
          response = await axios.put(this.baseDomain + this.shopId + '/deliverymethodgroups/' + data.id + '.json?apikey=' + this.apiKey, data)
        } else {
          delete data.id
          response = await axios.post(this.baseDomain + this.shopId + '/deliverymethodgroups.json?apikey=' + this.apiKey, data)
        }
      } catch(e) {
        this.saving = false
        return this.showError(e)
      }
      if (response && response.data && response.data.id) {
        await this.loadDeliverymethodgroup(response.data.id)
      }
      this.saving = false
      this.saved = true
      setTimeout(() => { this.saved = false }, 1000)
      this.showNotification(this._('Changes saved successfully!'))
      this.$emit('save', this.resource)
      if (this.saveShouldClose) {
        this.close()
      }
    },
    loadDeliverymethodgroup (id) {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/deliverymethodgroups/' + id + '.json?apikey=' + this.apiKey)
        } catch (e) {
          this.loading = false
          this.showError(e)
          reject()
          return
        }
        this.deliverymethodgroup = response.data
        if (!this.deliverymethodgroup.ownDeliverymethod) {
          this.deliverymethodgroup.ownDeliverymethod = []
        }
        const loaders = []
        loaders.push(this.loadDeliverymethods())
        await Promise.allSettled(loaders)
        this.storeState()
        this.loading = false
        resolve(this.deliverymethodgroup)
      })
    },
    loadDeliverymethods () {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/deliverymethods.json?apikey=' + this.apiKey)
        } catch(e) {
          this.showError(e)
          resolve([])
          return
        }
        this.deliverymethods = response.data
        resolve(this.deliverymethods)
      })
    },
  },
  created () {
    if (this.component && this.component.initData) {
      this.loadDeliverymethodgroup(this.component.initData.deliverymethodgroupId)
    }
  },
  mounted () {
    if(!this.events) {
      let events = {}
      events['deliverymethodgroupUpdate'] = async (message) => {
        if (message && message.data && this.deliverymethodgroup && parseInt(message.data.id, 10) === parseInt(this.deliverymethodgroup.id, 10)) {
          if (!this.unsavedChanges) { // Only update if we haven't made any changes
            this.loadDeliverymethodgroup(message.data.id)
          }
        }
      }
      this.events = events
    }
    this.enableEventBus()
  },
  async updated () {
    if (this.component && this.component.initData) {
      if (this.deliverymethodgroup && this.deliverymethodgroup.id && parseInt(this.deliverymethodgroup.id, 10) !== parseInt(this.component.initData.deliverymethodgroupId, 10)) {
        try {
          await this.loadDeliverymethodgroup(this.component.initData.deliverymethodgroupId)
        } catch(e) {}
      }
    }
  }
}
</script>
